import { atom } from 'jotai';

export namespace dti {
  export const currentModalAtom = atom<string | null>(null);
}
